<span class="material-symbols-rounded">{{ stateIcon }}</span>
<div>{{text}}</div>
@if (showCloseButton) {
  <button mat-stroked-button [mat-dialog-close]>{{'UI.Noconnect.Button.Close|Ok' | translate}}</button>
}
